export enum TabsProfileTypes {
  MIJN_PROFIEL = 'MIJN_PROFIEL',
  TEAM = 'TEAM',
  UITLOGGEN = 'UITLOGGEN',
}
